import React from 'react';
import { Card, CardHeader, CardBody, Table, Button, Badge } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { INVALIDATE_ROARING_INDEX, WARM_ROARING_INDEX } from '@api';

function staleBadge(staleMs, built) {
  if (!built) return <Badge color='secondary'>not built</Badge>;
  if (staleMs == null) return <Badge color='secondary'>?</Badge>;
  const secs = Math.floor(staleMs / 1000);
  if (secs < 120) return <Badge color='success'>{secs}s</Badge>;
  if (secs < 600) return <Badge color='warning'>{Math.floor(secs / 60)}m</Badge>;
  return <Badge color='danger'>{Math.floor(secs / 60)}m</Badge>;
}

export default function RoaringIndexPanel({ entries, onDone }) {
  const [invalidate, { loading: invLoading }] = useMutation(INVALIDATE_ROARING_INDEX, {
    onCompleted: (d) => { toast.success(d?.invalidateRoaringIndex?.message || 'Invalidated'); onDone && onDone(); },
    onError: (e) => toast.error(e.message),
  });
  const [warm, { loading: warmLoading }] = useMutation(WARM_ROARING_INDEX, {
    onCompleted: (d) => { toast.success(d?.warmRoaringIndex?.message || 'Warmed'); onDone && onDone(); },
    onError: (e) => toast.error(e.message),
  });

  const busy = invLoading || warmLoading;

  const rebuildAll = () => {
    if (!window.confirm('Rebuild ALL roaring indexes? This will invalidate + rebuild every city.')) return;
    invalidate({ variables: { rebuild: true } });
  };

  return (
    <Card>
      <CardHeader style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <strong>Roaring Index</strong>
        <span style={{ marginLeft: 'auto' }}>
          <Button size='sm' color='primary' disabled={busy} onClick={rebuildAll}>Rebuild All</Button>
        </span>
      </CardHeader>
      <CardBody style={{ padding: 0, maxHeight: 360, overflowY: 'auto' }}>
        <Table size='sm' responsive className='mb-0'>
          <thead>
            <tr>
              <th>City</th>
              <th>Size</th>
              <th>Built</th>
              <th>Age</th>
              <th style={{ width: 140 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {entries.length === 0 && (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: '#888' }}>No cities</td></tr>
            )}
            {entries.map((e) => (
              <tr key={e.cityId}>
                <td>{e.cityName || `city#${e.cityId}`}</td>
                <td>{e.size}</td>
                <td>{e.builtAt ? new Date(e.builtAt).toLocaleTimeString() : '—'}</td>
                <td>{staleBadge(e.staleMs, e.built)}</td>
                <td>
                  <Button
                    size='sm'
                    color='warning'
                    className='mr-1'
                    disabled={busy}
                    onClick={() => invalidate({ variables: { cityId: e.cityId, rebuild: true } })}
                  >Rebuild</Button>
                  <Button
                    size='sm'
                    color='light'
                    disabled={busy}
                    onClick={() => warm({ variables: { cityId: e.cityId } })}
                  >Warm</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
}
